import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useCurrentUser } from 'javascripts/hooks';
import { get as lodashGet } from 'lodash';
import Comment from './Comment';
import VoiceNote from './VoiceNote';
import { ButtonCondensed } from '@companycam/slab-web';

const CommentList = ({
  activityItems,
  fetchingResults,
  canLoadMore,
  loadMore,
}) => {
  const currentUser = useCurrentUser();
  const commentEntryContainer = useRef();
  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(
    () => {
      if (commentEntryContainer.current && !fetchingResults && !hasScrolled) {
        const children = commentEntryContainer.current.children;
        const last = children[children.length - 1];
        if (last) {
          commentEntryContainer.current.parentElement.scrollTop =
            last.offsetTop;
          setHasScrolled(true);
        }
      }
    },
    [fetchingResults, hasScrolled, setHasScrolled],
  );

  const renderItem = (item) => {
    const contributorType = lodashGet(
      item,
      'contributor.__typename',
      'Unknown',
    );
    const contributorNodeId = lodashGet(item, 'contributor.id', '0');
    const isCurrentUser =
      contributorType === 'ProjectContributingUser' &&
      contributorNodeId === currentUser.node_id;

    switch (item.__typename) {
      case 'Comment':
        return (
          <Comment key={item.id} isCurrentUser={isCurrentUser} comment={item} />
        );
      case 'VoiceNote':
        return (
          <VoiceNote
            key={item.id}
            isCurrentUser={isCurrentUser}
            voiceNote={item}
          />
        );
      default:
        return null;
    }
  };

  const items = activityItems.map(renderItem);

  return (
    <div className="comment-scroll-container">
      {!canLoadMore ? null : (
        <ButtonCondensed
          color="primary"
          size="small"
          style={{ marginBottom: 16 }}
          icon={{
            name: 'refresh',
            position: 'before',
          }}
          onClick={(e) => {
            e.preventDefault();
            if (!fetchingResults) {
              loadMore();
            }
          }}
        >
          Load more comments…
        </ButtonCondensed>
      )}
      {activityItems.length > 0 ? (
        <div className="comment-set" ref={commentEntryContainer}>
          {items}
        </div>
      ) : null}
    </div>
  );
};

CommentList.propTypes = {
  fetchingResults: PropTypes.bool,
  activityItems: PropTypes.array, // Array of CommentFragment, VoiceNoteFragment
  canLoadMore: PropTypes.bool,
  loadMore: PropTypes.func,
};

export default CommentList;
